<template>
	<div class="pdf-view px-12 py-10" v-if="pdf && pdf.type && pdf.type.slug == 'file_pdf'">
		<template v-if="loadingTask">
			<PDFViewer
			class="shadow mb-8"
			v-for="i in pageCount"
			:id="'page-' + i"
			:key="i"
			:src="loadingTask"
			:page="i"
			ref="page" />			
		</template>

		<div class="faa-loader" v-if="isLoading">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</div>
	</div>
</template>

<script>
	import PDFViewer from 'vue-pdf'

	export default {
		name: 'PDFView',
		props: {
			pdf: {
				type: Object,
				required: false,
				default: null
			}
		},
		components: {
			PDFViewer,
		},
		data(){
			return {
				isLoading: false,
				pageCount: 0,
				loadingTask: null,
			}
		},
		watch: {
			pdf: {
				handler(pdf) {
					if (pdf && pdf.url) {
						this.isLoading = true

						if (this.$el && this.$el.parentElement) {
							this.$el.parentElement.scrollTop = 0
						}

						this.loadingTask = PDFViewer.createLoadingTask(pdf.url)

						this.loadingTask.promise.then(file => {
							this.pageCount = file.numPages;
							setTimeout(() => {
								this.isLoading = false
							}, 500)
						})
					} else {
						this.loadingTask = null
					}
				},
				immediate: true,
			}
		},
		methods: {
			scrollToPage(nextPage) {
				// todo: improve for previous page when at the end of one + when in the middle of one ?
				if (!this.$el || !this.$refs.page)
					return

				const scrollContainer = this.$el.parentElement

				const modal = scrollContainer.parentElement
				const header = modal.children[0]
				const topDelta = (modal.offsetTop + header.offsetHeight) + 15

				for (var i = 0; i < this.pageCount; i++) {
					const elm = this.$refs.page[i].$el

					// Get current visible page
					const elmZone = {
						top: (elm.offsetTop - topDelta),
						bottom: (elm.offsetTop - topDelta) + elm.offsetHeight,
					}
					if (
						(scrollContainer.scrollTop >= elmZone.top && scrollContainer.scrollTop <= elmZone.bottom) || 
						scrollContainer.scrollTop < elmZone.top
						) {

						// Scroll to next/previous element
						if (nextPage && i < (this.pageCount - 1)) {
							scrollContainer.scrollTop = this.$refs.page[i + 1].$el.offsetTop - topDelta
						} else if (!nextPage && i > 0) {
							scrollContainer.scrollTop = this.$refs.page[i - 1].$el.offsetTop - topDelta
						}

						break
					}
				}
			},
			previousPage() {
				this.scrollToPage(false)
			},
			nextPage() {
				this.scrollToPage(true)
			},
		},
	}
</script>

<style lang="scss" scoped>

.pdf-view {
	min-height: 10rem;
}

.faa-loader span {
	@apply bg-gray-dark;
}
</style>
